module.exports = __webpack_public_path__ + "media/assets/images/flags/cg-7d84d980080a4294d07d1a74762712d9.svg";